import { render, staticRenderFns } from "./ProductsAddNewProduct.vue?vue&type=template&id=3f94522a&"
import script from "./ProductsAddNewProduct.vue?vue&type=script&lang=js&"
export * from "./ProductsAddNewProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports